export class ModelSettings {
  ModelName: string;
  EmailAddress: string;
  Action: string;
  EnsemblingMethod: string;
  StudentIdCol: number;
  StudentResponseCol: number;
  ScoringColumnStart: number;
  NumberOfScoringCols: number;
  ShowIndividualAlgoResults: boolean;
  RunIndividualAlgo: boolean;
  UseDefaultStopWords: boolean;
  UseCustomStopWords: boolean;
  KeepNumbers: boolean;
  StopWords: string[];
  Predicting: boolean;
  ExportType: string;
  ShowIndividualTables: boolean;
  Holistic: boolean;
  Analytic: boolean;
  Binary: boolean;
  Svm: boolean;
  Lda: boolean;
  Rf: boolean;
  Logit: boolean;
  Maxent: boolean;
  Bagging: boolean;
  Glment: boolean;
  NgramLength: number;
  AlgoToRun: string;
}
